import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBuilding,
  faCalendarAlt,
  faUser,
  faLayerGroup,
  faBook,
  faBoxes,
  faBox,
  faCogs,
  faUserTie,
  faTruck,
  faUsers,
  faUserSecret,
  faMapMarkerAlt,
  faQrcode,
  faFileAlt,
  faAddressBook,
  faFileInvoice,
  faFileSignature,
  faPlusSquare,
  faReceipt,
  faMoneyBill,
  faExchangeAlt,
  faJournalWhills,
  faFileUpload,
  faFileDownload,
  faMinusCircle,
  faPlusCircle,
  faDollyFlatbed,
  faFileInvoiceDollar,
  faFileContract,
  faCashRegister,
  faUniversity,
  faBalanceScale,
  faChartPie,
  faChartLine,
  faLock,
  faHistory,
  faClipboardList,
  faFileExcel,
  faChartBar,
  faIndustry,
  faHandsHelping,
  faProjectDiagram,
  faShieldAlt,
  faLeaf,
  faAd,
  faComments,
  faBookReader,
  faCertificate,
  faUsersCog,
  faCar,
  faTools,
  faChalkboardTeacher,
  faClone,
  faBookOpen,
  faDollar,
  faToolbox
} from "@fortawesome/free-solid-svg-icons";

export const tabs = [
  {
    name: "Masters",
    icon: faCogs,
    whatIsThis: "Setup and manage all foundational data required for accounting and operations.",
    items: [
      { name: "Company", icon: faBuilding, itemroute: "/ledger-masters-company", whatIsThis: "Create and manage company details for ledger operations." },
      { name: "Financial Period", icon: faCalendarAlt, itemroute: "/ledger-masters-financial-period", whatIsThis: "Define financial year periods for reporting." },
      { name: "User", icon: faUser, itemroute: "/ledger-masters-user", whatIsThis: "Add and manage system users with access control." },
      { name: "A/C Group", icon: faLayerGroup, itemroute: "/ledger-masters-ac-group", whatIsThis: "Organize ledgers into groups for easy tracking." },
      { name: "A/C Ledger", icon: faBook, itemroute: "/ledger-masters-ac-ledger", whatIsThis: "Maintain individual account ledgers." },
      { name: "Item Group", icon: faBoxes, itemroute: "/ledger-masters-item-group", whatIsThis: "Categorize items into groups." },
      { name: "Item", icon: faBox, itemroute: "/ledger-masters-item", whatIsThis: "Create and manage inventory/service items." },
      { name: "Asset", icon: faCogs, itemroute: "/ledger-masters-asset", whatIsThis: "Track and manage company assets." },
      { name: "Customer", icon: faUserTie, itemroute: "/ledger-masters-customer", whatIsThis: "Maintain customer information for billing." },
      { name: "Supplier", icon: faTruck, itemroute: "/ledger-masters-supplier", whatIsThis: "Maintain supplier/vendor information." },
      { name: "Employee", icon: faUsers, itemroute: "/ledger-masters-employee", whatIsThis: "Maintain employee master data." },
      { name: "Competitor", icon: faUserSecret, itemroute: "/ledger-masters-competitor", whatIsThis: "Keep records of competitors for analysis." },
      { name: "Location", icon: faMapMarkerAlt, itemroute: "/ledger-masters-location", whatIsThis: "Define locations such as branches, stores, or warehouses." },
      { name: "Batch", icon: faLayerGroup, itemroute: "/ledger-masters-batch", whatIsThis: "Manage batch numbers for stock and expiry tracking." },
      { name: "QR Code", icon: faQrcode, itemroute: "/ledger-masters-qr-code", whatIsThis: "Generate and manage QR codes for items or invoices." },
      { name: "Document", icon: faFileAlt, itemroute: "/ledger-masters-document", whatIsThis: "Store reference documents related to masters." },
      { name: "Key Contact", icon: faAddressBook, itemroute: "/ledger-masters-key-contact", whatIsThis: "Maintain important contact persons." },
      { name: "Invoice Setup", icon: faFileInvoice, itemroute: "/ledger-masters-invoice-setup", whatIsThis: "Configure invoice formats and details." },
      { name: "Voucher Setup", icon: faFileSignature, itemroute: "/ledger-masters-voucher-setup", whatIsThis: "Configure voucher types and templates." },
      { name: "Prefix-Suffix", icon: faPlusSquare, itemroute: "/ledger-masters-prefix-suffix", whatIsThis: "Setup numbering rules for vouchers and documents." },
    ],
  },
  {
    name: "Voucher",
    icon: faReceipt,
    whatIsThis: "Record daily financial transactions using vouchers.",
    items: [
      { name: "Receipt", icon: faReceipt, itemroute: "/ledger-voucher-receipt", whatIsThis: "Record incoming payments." },
      { name: "Payment", icon: faMoneyBill, itemroute: "/ledger-voucher-payment", whatIsThis: "Record outgoing payments." },
      { name: "Contra", icon: faExchangeAlt, itemroute: "/ledger-voucher-contra", whatIsThis: "Record cash/bank transfers within accounts." },
      { name: "Journal", icon: faJournalWhills, itemroute: "/ledger-voucher-journal", whatIsThis: "Record adjustments, depreciation, or non-cash entries." },
      { name: "GST Filing", icon: faFileUpload, itemroute: "/ledger-voucher-gst-filing", whatIsThis: "Prepare GST-related vouchers for filing." },
      { name: "Debit Note", icon: faMinusCircle, itemroute: "/ledger-voucher-debit-note", whatIsThis: "Issue debit notes against suppliers or adjustments." },
      { name: "Credit Note", icon: faPlusCircle, itemroute: "/ledger-voucher-credit-note", whatIsThis: "Issue credit notes for customers or adjustments." },
      { name: "Stock Transfer", icon: faDollyFlatbed, itemroute: "/ledger-voucher-stock-transfer", whatIsThis: "Record transfer of stock between locations." },
      { name: "Purchase", icon: faFileInvoiceDollar, itemroute: "/ledger-voucher-purchase", whatIsThis: "Record purchase transactions." },
    ],
  },
  {
    name: "Bills & Stock",
    icon: faFileInvoiceDollar,
    whatIsThis: "Generate bills and manage stock movement.",
    items: [
      { name: "Tax Invoice", icon: faFileInvoiceDollar, itemroute: "/ledger-bills-tax-invoice", whatIsThis: "Create and print tax invoices." },
      { name: "Proforma Invoice", icon: faFileAlt, itemroute: "/ledger-bills-proforma-invoice", whatIsThis: "Generate proforma invoices before final billing." },
      { name: "Challan", icon: faFileContract, itemroute: "/ledger-bills-challan", whatIsThis: "Generate delivery challans for stock movement." },
    ],
  },
  {
    name: "Reports",
    icon: faChartPie,
    whatIsThis: "View financial and operational reports.",
    items: [
      { name: "Cash Book", icon: faCashRegister, itemroute: "/ledger-reports-cash-book", whatIsThis: "Track daily cash transactions." },
      { name: "Bank Book", icon: faUniversity, itemroute: "/ledger-reports-bank-book", whatIsThis: "Track bank transactions." },
      { name: "Ledger", icon: faBook, itemroute: "/ledger-reports-ledger", whatIsThis: "View account ledger reports." },
      { name: "Journal", icon: faJournalWhills, itemroute: "/ledger-reports-journal", whatIsThis: "View journal entries report." },
      { name: "Invoice", icon: faFileInvoice, itemroute: "/ledger-reports-invoice", whatIsThis: "Generate invoice reports." },
      { name: "Income-Expenditure", icon: faBalanceScale, itemroute: "/ledger-reports-income-expenditure", whatIsThis: "Check income vs expenditure statement." },
      { name: "Trial Balance", icon: faBalanceScale, itemroute: "/ledger-reports-trial-balance", whatIsThis: "Check debit-credit balance before final accounts." },
      { name: "Balance Sheet", icon: faChartBar, itemroute: "/ledger-reports-balance-sheet", whatIsThis: "View balance sheet report." },
      { name: "Petty Cash Book", icon: faCashRegister, itemroute: "/ledger-reports-petty-cash-book", whatIsThis: "Track small cash expenses." },
      { name: "Bank Reconciliation", icon: faUniversity, itemroute: "/ledger-reports-bank-reconciliation", whatIsThis: "Reconcile bank statement with ledger." },
      { name: "Account Reconciliation", icon: faClipboardList, itemroute: "/ledger-reports-account-reconciliation", whatIsThis: "Match account balances across ledgers." },
      { name: "Sales Register", icon: faFileExcel, itemroute: "/ledger-reports-sales-register", whatIsThis: "Check all sales transactions report." },
      { name: "GST Reports", icon: faFileUpload, itemroute: "/ledger-reports-gst-reports", whatIsThis: "Generate GST summary reports." },
      { name: "Purchase Register", icon: faFileExcel, itemroute: "/ledger-reports-purchase-register", whatIsThis: "Check all purchase transactions report." },
      { name: "Stock Register", icon: faBoxes, itemroute: "/ledger-reports-stock-register", whatIsThis: "Track stock inflow/outflow." },
      { name: "MTD Reports", icon: faChartLine, itemroute: "/ledger-reports-mtd", whatIsThis: "Month-to-date performance reports." },
      { name: "YTD Reports", icon: faChartLine, itemroute: "/ledger-reports-ytd", whatIsThis: "Year-to-date performance reports." },
    ],
  },
  {
    name: "MIS & DSS",
    icon: faChartLine,
    whatIsThis: "Decision support and management information system reports.",
    items: [
      { name: "Ratios", icon: faChartPie, itemroute: "/ledger-mis-ratios", whatIsThis: "View financial ratios for analysis." },
      { name: "Receivables", icon: faMoneyBill, itemroute: "/ledger-mis-receivables", whatIsThis: "Check outstanding customer payments." },
      { name: "Payables", icon: faMoneyBill, itemroute: "/ledger-mis-payables", whatIsThis: "Check pending supplier payments." },
      { name: "Ageing", icon: faHistory, itemroute: "/ledger-mis-ageing", whatIsThis: "Analyse ageing of receivables and payables." },
      { name: "Locationwise Report", icon: faMapMarkerAlt, itemroute: "/ledger-mis-locationwise", whatIsThis: "View performance report by location." },
      { name: "Confidential", icon: faLock, itemroute: "/ledger-mis-confidential", whatIsThis: "Restricted confidential MIS reports." },
      { name: "Users", icon: faUsersCog, itemroute: "/ledger-mis-users", whatIsThis: "User activity and access analysis." },
    ],
  },
  {
    name: "Utilities",
    icon: faTools,
    whatIsThis: "Perform supporting and technical utility operations.",
    items: [
      { name: "Year Closing", icon: faCalendarAlt, itemroute: "/ledger-utilities-year-closing", whatIsThis: "Close books of accounts for a financial year." },
      { name: "Import Data", icon: faFileUpload, itemroute: "/ledger-utilities-import", whatIsThis: "Import data from external sources." },
      { name: "Export Data", icon: faFileDownload, itemroute: "/ledger-utilities-export", whatIsThis: "Export system data to external formats." },
      { name: "Voucher Cloning", icon: faClone, itemroute: "/ledger-utilities-voucher-cloning", whatIsThis: "Duplicate vouchers for reuse." },
      { name: "Bill Cloning", icon: faClone, itemroute: "/ledger-utilities-bill-cloning", whatIsThis: "Duplicate bills for reuse." },
    ],
  },
  {
    name: "Housekeeping",
    icon: faToolbox,
    whatIsThis: "Maintain system hygiene and data security.",
    items: [
      { name: "Repair Vouchers", icon: faTools, itemroute: "/ledger-housekeeping-repair-vouchers", whatIsThis: "Fix or clean voucher data issues." },
      { name: "Lock Period", icon: faLock, itemroute: "/ledger-housekeeping-lock-period", whatIsThis: "Lock financial periods from modification." },
      { name: "Lock Account", icon: faLock, itemroute: "/ledger-housekeeping-lock-account", whatIsThis: "Restrict changes in specific accounts." },
      { name: "Lock User", icon: faLock, itemroute: "/ledger-housekeeping-lock-user", whatIsThis: "Restrict or deactivate user access." },
    ],
  },
  {
    name: "Logs",
    icon: faClipboardList,
    whatIsThis: "Audit and track all system activities.",
    items: [
      { name: "Access Log", icon: faClipboardList, itemroute: "/ledger-logs-access-log", whatIsThis: "Track user login and access." },
      { name: "Change Log", icon: faClipboardList, itemroute: "/ledger-logs-change-log", whatIsThis: "Track system or data modifications." },
      { name: "Cloning Log", icon: faClipboardList, itemroute: "/ledger-logs-cloning-log", whatIsThis: "Track cloning activities of vouchers and bills." },
    ],
  },
  {
    name: "Useful Resources",
    icon: faHandsHelping,
    whatIsThis: "Extra modules and business resources.",
    items: [
      { name: "HRMS", icon: faUsersCog, itemroute: "/ledger-resources-hrms-management", whatIsThis: "Manage human resource functions." },
      { name: "Assets Management", icon: faCogs, itemroute: "/ledger-resources-assets-management", whatIsThis: "Track and manage company assets lifecycle." },
      { name: "Fleet Management", icon: faCar, itemroute: "/ledger-resources-fleet-management", whatIsThis: "Manage vehicles and fleet operations." },
      { name: "Lead Management", icon: faProjectDiagram, itemroute: "/ledger-resources-lead-management", whatIsThis: "Track and manage business leads." },
      { name: "Complaint Management", icon: faComments, itemroute: "/ledger-resources-complaint-management", whatIsThis: "Record and resolve customer complaints." },
      { name: "Process Management", icon: faProjectDiagram, itemroute: "/ledger-resources-process-management", whatIsThis: "Define, monitor, and improve processes." },
      { name: "Quality Management", icon: faChartBar, itemroute: "/ledger-resources-quality-management", whatIsThis: "Track quality KPIs and compliance." },
      { name: "Process Maturity Audit", icon: faClipboardList, itemroute: "/ledger-resources-process-maturity-audit", whatIsThis: "Audit process maturity levels." },
      { name: "Digital & Cybersecurity Maturity", icon: faShieldAlt, itemroute: "/ledger-resources-digital-cyber-maturity", whatIsThis: "Assess and improve digital security maturity." },
      { name: "RCA", icon: faCogs, itemroute: "/ledger-resources-rca", whatIsThis: "Perform root cause analysis." },
      { name: "ESG", icon: faLeaf, itemroute: "/ledger-resources-esg", whatIsThis: "Track Environmental, Social & Governance metrics." },
      { name: "Digital Advertisement", icon: faAd, itemroute: "/ledger-resources-digital-advertisement", whatIsThis: "Plan and manage digital ads." },
      { name: "Marketplace", icon: faIndustry, itemroute: "/ledger-resources-marketplace", whatIsThis: "Access business marketplace platform." },
      { name: "Discussion Forum", icon: faComments, itemroute: "/ledger-resources-discussion-forum", whatIsThis: "Participate in community discussions." },
    ],
  },
  {
    name: "Owner Work-Life",
    icon: faUsers,
    whatIsThis: "Owner’s personal and professional enrichment tools.",
    items: [
      { name: "Work Chronicles", icon: faBookReader, itemroute: "/msme-self-chronicles", whatIsThis: "Maintain personal or business chronicles." },
      { name: "Literacy", icon: faBook, itemroute: "/bookworld", whatIsThis: "Access financial and business literacy content." },
      { name: "Certification", icon: faCertificate, itemroute: "/my-certificates-others", whatIsThis: "Get certifications for skills or compliance." },
      { name: "Self & Family", icon: faUsers, itemroute: "/msme-self-chronicles", whatIsThis: "Manage family-related records." },
    ],
  },
  {
    name: "Help",
    icon: faHandsHelping,
    whatIsThis: "Guides and support materials for users.",
    items: [
      { name: "About", icon: faBookReader, itemroute: "/ledger-help-about", whatIsThis: "Information about the system." },
      { name: "User Guide", icon: faBookOpen, itemroute: "/ledger-help-user-guide", whatIsThis: "Step-by-step guide for users." },
      { name: "Tutorial", icon: faChalkboardTeacher, itemroute: "/ledger-help-tutorial", whatIsThis: "Interactive learning modules." },
      { name: "Troubleshooting", icon: faTools, itemroute: "/ledger-help-troubleshooting", whatIsThis: "Fix common issues and errors." },
    ],
  },
  {
    name: "Monetise",
    icon: faDollar,
    whatIsThis: "Earn by referring or using monetization tools.",
    items: [
      { name: "Refer", icon: faDollyFlatbed, itemroute: "/orderflow-earning-estimator", whatIsThis: "Refer and earn rewards." },
    ],
  },
];

export default function ThinkLedgerHome() {
  const [activeTab, setActiveTab] = useState(null);
  const navigate = useNavigate();
  const [hoveredItem, setHoveredItem] = useState(null);

  return (
    <div className="flex flex-col min-h-screen bg-black text-white">
      <header className="bg-black text-white border-b border-blue-400 p-4 text-center text-xl font-bold sticky top-0 z-50">
        📒 ThinkLedger: Accounting & Inventory Management for MSMEs and All
      </header>

      <main className="flex-1 px-2 py-4">
        {/* Tabs */}
        <section>
          <div className="grid grid-cols-4 lg:grid-cols-12 gap-2 place-items-center">
            {tabs.map((tab, idx) => (
              <div
                key={idx}
                onClick={() => setActiveTab(idx)}
                className={`flex flex-col items-center justify-center p-4 rounded-lg text-center
                  transition-colors duration-200
                  ${
                    activeTab === idx
                      ? "bg-gray-800 text-white"
                      : "bg-black text-white hover:bg-gray-800 hover:text-yellow-200"
                  }`}
                style={{ minHeight: "90px" }}
              >
                <FontAwesomeIcon
                  icon={tab.icon}
                  className="mb-2 text-base lg:text-lg transition-colors"
                  style={{ color: activeTab === idx ? "#1E90FF" : "#3B82F6" }}
                />
                <span className="text-xs lg:text-sm">{tab.name}</span>
              </div>
            ))}
          </div>

          {activeTab !== null && (
            <div className="mt-2 p-2 rounded-lg text-sm text-center text-yellow-200">
              {tabs[activeTab].whatIsThis}
            </div>
          )}
        </section>

        {/* Items Grid */}
        {activeTab !== null && tabs[activeTab]?.items?.length > 0 && (
          <section className="mt-4">
            <div className="grid grid-cols-3 lg:grid-cols-12 gap-2 place-items-center">
              {tabs[activeTab].items.map((item, idx) => (
                <div
                  key={idx}
                  onMouseEnter={() => setHoveredItem(idx)}
                  onMouseLeave={() => setHoveredItem(null)}
                  onClick={() =>
                    item.itemroute
                      ? navigate(item.itemroute)
                      : alert(`Route not defined for "${item.name}"`)
                  }
                  className="flex flex-col items-center justify-center p-3 rounded-lg bg-black text-white 
                             hover:bg-gray-800 hover:text-yellow-200 transition-colors duration-200"
                  style={{ minHeight: "90px" }}
                >
                  <FontAwesomeIcon
                    icon={item.icon}
                    className="mb-2 text-lg lg:text-xl"
                    style={{ color: "#22C55E" }}
                  />
                  <span className="text-xs lg:text-sm text-center">{item.name}</span>
                </div>
              ))}
            </div>

            {/* Hover Description */}
            {hoveredItem !== null &&
              tabs[activeTab]?.items[hoveredItem] && (
                <div className="mt-2 p-2 rounded-lg text-sm text-center text-white">
                  {tabs[activeTab].items[hoveredItem].whatIsThis}
                </div>
              )}
          </section>
        )}
      </main>

      {/* Sticky Footer */}
      <footer className="bg-black border-t border-blue-400 text-gray-400 py-4 sticky bottom-0 z-50">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
